import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { sentryInstance } from "./app/core/sentry/sentry.util";
import { AppModule } from "./app/modules/app/app.module";
import { environment } from "./environments/environment";

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    LOQ: any[];
  }
}

if (environment.production) {
  enableProdMode();
}

if (environment.sentryEnable) {
  sentryInstance();
}

if (environment.luckyOrangeUrl) {
  const luckyOrangeScript = document.createElement("script");
  luckyOrangeScript.src = environment.luckyOrangeUrl;
  luckyOrangeScript.async = true;
  luckyOrangeScript.defer = true;
  document.body.appendChild(luckyOrangeScript);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
